import { render } from "./StockCard.vue?vue&type=template&id=f2b62f34&scoped=true"
import script from "./StockCard.vue?vue&type=script&lang=js"
export * from "./StockCard.vue?vue&type=script&lang=js"

import "./StockCard.vue?vue&type=style&index=0&id=f2b62f34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b62f34"]])

export default __exports__